export default "__VITE_ASSET__CRXeUr$M__"